module.exports = __webpack_public_path__ + "img/dw_6.c294c469.png";